export default __webpack_public_path__ + "static/media/send.2eb83763.svg";